// extracted by mini-css-extract-plugin
export var bear = "polar-module--bear--510c0";
export var contentWrapper = "polar-module--contentWrapper--eaa7e";
export var ctaBtn = "polar-module--ctaBtn--c0a2c";
export var gradient = "polar-module--gradient--24073";
export var message = "polar-module--message--bfbfb";
export var moveIcon = "polar-module--moveIcon--56472";
export var subhead = "polar-module--subhead--e9faf";
export var title = "polar-module--title--83931";